// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__3BZHW","btnRed":"styles_btnRed__1Gte0","row":"styles_row__3KNEy","left":"styles_left__3nFTd","right":"styles_right__-2E-3"};